//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'PIROVAP',
  data() {
    return {
      "comorbiditiesHintText": "包括：\n• COPD\n• 免疫减退\n• 慢性心衰\n• 慢性肝病\n• 慢性肾病",
      form:{
        comorbidities:'0',
        bacteremia:'0',
        systolic:'0',
        ards:'0'
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '0'
      } else {
        // (comorbidities ? 1 : 0) + (bacteremia ? 1 : 0) + (systolic ? 1 : 0) + (ards ? 1 : 0)
        let result = (form.comorbidities ? 1 : 0) + (form.bacteremia ? 1 : 0) + (form.systolic ? 1 : 0) + (form.ards ? 1 : 0)
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/PIROVAP.vue